import type { ITestimonial } from "@gik/core/models/gik/ITestimonial";
import bemBlock from "@gik/core/utils/bemBlock";
import type { IBoxCarouselProps } from "@gik/ui-legacy/gik/BoxCarousel";
import { BoxCarousel } from "@gik/ui-legacy/gik/BoxCarousel";
import classnames from "classnames";
import type React from "react";

import type { UIBoxVariant } from "../../types";
import { TestimonialsCarouselCard } from "./TestimonialsCarouselCard";

export interface ITestimonialsCarouselProps extends IBoxCarouselProps {
	items?: ITestimonial[];
	variant?: UIBoxVariant;
}

export function TestimonialsCarousel({
	items,
	className,
	fadeSides = true,
	contained = true,
	variant = "primary",
	...otherProps
}: ITestimonialsCarouselProps): React.ReactElement {
	const bem = bemBlock("testimonials-carousel");
	const blockClasses = classnames([bem(), className || ""]);

	return (
		<BoxCarousel
			variant={variant}
			fadeSides={fadeSides}
			contained={contained}
			className={blockClasses}
			{...otherProps}
		>
			{items?.map((item: ITestimonial, index) => (
				<TestimonialsCarouselCard key={index} {...item} />
			))}
		</BoxCarousel>
	);
}
